import {NavLink as Link} from 'react-router-dom';
import React from 'react';
import './Entity.scss';
import ImageResponsive from './ImageResponsive';
import {generateEditLink, mapContentType} from '../misc/utils';


class Entity extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      added: false
    };
  }

  render() {
    const entity = this.props.entity;
    // console.log('Entity', entity);

    let title = entity.title;
    if (entity.name !== '' && !title) {
      title = entity.name;
    }

    let editUrl = generateEditLink(entity.contentType, entity.id);
    // Support for a manual URL passed in the allowEdit parameter
    if (this.props.allowEdit && this.props.allowEdit !== true) {
      editUrl = this.props.allowEdit;
    }

    let status = {
      text: 'Ikke publisert',
      class: 'alert-warning'
    };
    if (entity.published === true) {
      if (entity.updated) {
        status = {
          text: 'Oppdatert',
          class: 'alert-info'
        };
      } else {
        status = {
          text: 'Publisert',
          class: 'alert-success'
        };
      }
    }

    let contentType = mapContentType(entity.contentType);
    if (contentType === '' || contentType === undefined) {
      contentType = 'Entitet';
    }

    return (
      <div className="contentful-entity">
        <div className="contentful-entity-toolbar">
          <div className={`contentful-entity-header ${status.class}`} title={status.text}>
            <strong>{contentType}</strong>
          </div>
          <div className="contentful-entity-title">
            <h3>{title}</h3>
            {entity.contentType === 'color' && <div style={{
              width: '300px'
            }}>
              {entity.mainImage &&
                <ImageResponsive
                  src={entity.mainImage.url}
                  width={300}
                  height={200}
                />
              }
              <div className="text-muted">
                {entity.model && entity.model.name &&
                  <div>Modell: {entity.model.name}</div>
                }
                {entity.type &&
                  <div>Type: {entity.type}</div>
                }
                {entity.equipmentLevelWhitelist && entity.equipmentLevelWhitelist.length > 0 &&
                  <div>Utstyrsnivå: {entity.equipmentLevelWhitelist.map((lvl, i) => {
                    return <span key={i} className="span-list-item">{lvl.displayname}</span>;
                  })}</div>
                }
              </div>
            </div>}
            {entity.contentType === 'variant' &&
              <div className="text-muted">
                {entity.equipmentLevel && entity.equipmentLevel.displayname &&
                  <div>Utstyrsnivå: {entity.equipmentLevel.displayname}</div>
                }
              </div>
            }
            {entity.contentType === 'lease' &&
              <div className="text-muted">
                {entity.variant &&
                  <div>
                    <div>{entity.make && entity.make.name} {entity.model && entity.model.name}</div>
                    <span className="span-list-item">{entity.variant.displayname || entity.variant.name}</span>
                  </div>
                }
              </div>
            }
            {entity.contentType === 'leadSchema' &&
              <div className="text-muted">
                {entity.type &&
                  <div>{entity.type}</div>
                }
              </div>
            }
            {entity.contentType === 'model' &&
              <div className="text-muted">
                {entity.make && entity.make.name &&
                  <div>{entity.make.name}</div>
                }
              </div>
            }
            {entity.contentType === 'campaign' &&
              <div className="text-muted">
                {entity.summary &&
                  <div>{entity.summary}</div>
                }
              </div>
            }
            {entity.contentType === 'equipment' &&
              <div style={{
                width: '300px'
              }}>
                {entity.image &&
                  <ImageResponsive
                    src={entity.image.url}
                    width={300}
                    height={200}
                  />
                }
                <div className="row">
                  <div className="col-xs-6 mf-margin-top-10">
                    <strong>Varenr</strong>
                  </div>
                  <div className="col-xs-6 mf-margin-top-10">
                    {entity.eqId}
                  </div>

                  <div className="col-xs-6">
                    <strong>Kategori</strong>
                  </div>
                  <div className="col-xs-6">
                    {entity.category}
                  </div>

                  <div className="col-xs-6">
                    <strong>Pris</strong>
                  </div>
                  <div className="col-xs-6">
                    {entity.totalPrice}
                  </div>

                  <div className="col-xs-6">
                    <strong>Beskrivelse</strong>
                  </div>
                  <div className="col-xs-6">
                    <i>{entity.descriptionCustom ? 'Egendefinert' : 'Standard'}</i>
                  </div>
                </div>
              </div>
            }
            {entity.contentType === 'equipmentFactory' &&
              <div style={{
                width: '300px'
              }}>
                {entity.image &&
                  <ImageResponsive
                    src={entity.image.url}
                    width={300}
                    height={200}
                  />
                }
                <div className="row">
                  <div className="col-xs-6 mf-margin-top-10">
                    <strong>Utstyrskode</strong>
                  </div>
                  <div className="col-xs-6 mf-margin-top-10">
                    {entity.equipmentCode}
                  </div>

                  <div className="col-xs-6">
                    <strong>Pris</strong>
                  </div>
                  <div className="col-xs-6">
                    {entity.totalPrice}
                  </div>
                </div>
              </div>
            }
            {this.props.info}
          </div>
          <div className="contentful-entity-actions text-right">
            {Boolean(this.props.onSelect) &&
              <a
                className={`${this.props.disabled ? 'disabled ' : ''}btn btn-default`}
                disabled={this.state.added}
                onClick={() => {
                  this.props.onSelect(entity);
                  if (this.props.quickAdd) {
                    this.setState({
                      added: true
                    });
                  }
                }}
              >
                {this.state.added ? 'Lagt til' :
                  (this.props.quickAdd ? 'Legg til' : 'Velg')
                }
              </a>
            }
            {Boolean(this.props.allowEdit) && Boolean(this.props.onRemove) &&
              <span>&nbsp;</span>
            }
            {Boolean(this.props.allowEdit) &&
              /* <a
                className={(this.props.disabled ? 'disabled ' : '') + 'btn btn-default'}
              >
                <i className="fa fa-pencil" aria-hidden="true"></i> Endre
              </a>*/
              <Link
                to={editUrl}
                key={entity.id}
                className={`${this.props.disabled ? 'disabled ' : ''}btn btn-default`}
              >
                <i className="fa fa-pencil" aria-hidden="true"></i> Endre
              </Link>
            }
            {Boolean(this.props.allowEdit) && Boolean(this.props.onRemove) &&
              <span>&nbsp;</span>
            }
            {Boolean(this.props.onRemove) &&
              <a
                className={`${this.props.disabled ? 'disabled ' : ''}btn btn-default`}
                onClick={() => this.props.onRemove(entity)}
              >
                <i className="fa fa-times" aria-hidden="true"></i> Fjern
              </a>
            }
          </div>
        </div>
      </div>
    );
  }
}

Entity.defaultProps = {
  disabled: false
};

export default Entity;
